// src/utils/guide.js

// 스크롤과 리사이즈를 동시에 처리하는 함수
function handleScrollAndResize() {
  const scrollPosition = window.scrollY;
  const headerWrap = document.querySelector(".header_inner");
  const gnbWrap = document.querySelector(".gnb_wrap");
  const headerWrapElement = document.querySelector(".header_wrap");
  const gridContent = document.querySelector(".header_inner .grid_content");

  // 768px 이하일 때
  if (window.innerWidth <= 768) {
    // 스크롤이 있을 때 header를 위로 올리기
    if (scrollPosition > 0) {
      headerWrap.style.transform = `translateY(-44px)`;
      document.body.classList.add("scroll");
    } else {
      headerWrap.style.transform = `translateY(0)`;
      document.body.classList.remove("scroll");
    }

    // GNB를 header_wrap의 마지막 자식으로 이동
    if (gnbWrap && gnbWrap.parentElement !== headerWrapElement) {
      headerWrapElement.appendChild(gnbWrap);
    }
  } else {
    // 화면 크기가 768px 초과일 때
    if (gnbWrap && gnbWrap.parentElement !== gridContent) {
      gridContent.appendChild(gnbWrap); // grid_content 마지막 자식으로 이동
    }

    // transform 리셋
    headerWrap.style.transform = `translateY(0)`;
  }
}

// 리스너 추가
export function addListeners() {
  handleScrollAndResize();
  window.addEventListener("scroll", handleScrollAndResize);
  window.addEventListener("resize", handleScrollAndResize);
}

// 리스너 제거
export function removeListeners() {
  window.removeEventListener("scroll", handleScrollAndResize);
  window.removeEventListener("resize", handleScrollAndResize);
}

export function openLayer() {
  document.querySelectorAll(".open_click").forEach((button) => {
    const layer = button.nextElementSibling;

    if (layer && layer.classList.contains("layer_open")) {
      button.addEventListener("click", function (event) {
        document.querySelectorAll(".open_click").forEach((btn) => {
          if (btn !== button) {
            btn.setAttribute("aria-expanded", "false");
            const otherLayer = btn.nextElementSibling;
            if (otherLayer && otherLayer.classList.contains("layer_open")) {
              otherLayer.classList.remove("on");
            }
          }
        });

        const isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", isExpanded ? "false" : "true");
        layer.classList.toggle("on", !isExpanded);

        event.stopPropagation();
      });
    }
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest(".layer_open")) return;

    document.querySelectorAll(".open_click").forEach((button) => {
      button.setAttribute("aria-expanded", "false");
      const layer = button.nextElementSibling;
      if (layer && layer.classList.contains("layer_open")) {
        layer.classList.remove("on");
      }
    });
  });
}

export function accordion() {
  /** 아코디언 구조 .accordion > .acd_tit + .acd_cnt 가 한 세트 */
  const accordions = document.querySelectorAll(".accordion");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".acd_cnt");
    accordion.classList.add("on");
    content.style.maxHeight = "none";
  };
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".acd_cnt");
    accordion.classList.remove("on");
    content.style.maxHeight = null;
  };
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".acd_tit");
    const content = accordion.querySelector(".acd_cnt");

    intro.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion);
      }
    };
  });
  // openAccordion 함수를 반환하여 특정 항목을 수동으로 열 수 있게 함
  return { openAccordion, closeAccordion };
}

export function expand() {
  const expandBtns = document.querySelectorAll(".expand_btn"); // 모든 expand_btn 선택
  const sectionInners = document.querySelectorAll(".section_inner"); // 모든 section_inner 선택

  // 각 expand_btn과 section_inner에 대해 개별적으로 이벤트 리스너를 추가
  expandBtns.forEach((expandBtn, index) => {
    const sectionInner = sectionInners[index]; // index로 대응되는 section_inner 가져오기

    if (expandBtn && sectionInner) {
      expandBtn.addEventListener("click", () => {
        const isExpanded = sectionInner.classList.toggle("on");

        // 버튼 텍스트 변경
        expandBtn.innerHTML = `${isExpanded ? "접기" : "펼쳐보기"} <i class="icon expand"></i>`;

        // 접힐 때 맨 위 내용이 보이도록 스크롤 조정
        if (!isExpanded) {
          sectionInner.scrollTo({ top: 0 });
        }
      });
    }
  });
}

export function rolling() {
  document
    .querySelectorAll(".searched_company .searched_company_info .company_merit")
    .forEach((meritContainer) => {
      const meritList = meritContainer.querySelector("ul");
      const merits = meritList.querySelectorAll("li");
      if (merits.length <= 1) return; // 항목이 하나라면 롤링 불필요

      let interval;
      const itemHeight = merits[0].offsetHeight; // li 요소의 높이

      // 초기 스타일 설정
      meritList.style.transition = "transform 0.5s ease-in-out";

      function rollMerit() {
        // 리스트를 위로 이동
        meritList.style.transform = `translateY(-${itemHeight}px)`;

        // 애니메이션이 끝난 후 실행
        setTimeout(() => {
          const firstItem = meritList.firstElementChild;
          meritList.appendChild(firstItem); // 첫 번째 요소를 맨 뒤로 이동
          meritList.style.transition = "none"; // 트랜지션 비활성화
          meritList.style.transform = "translateY(0)"; // 원래 위치로 복귀

          // 다음 이동을 위해 트랜지션 다시 활성화
          setTimeout(() => {
            meritList.style.transition = "transform 0.5s ease-in-out";
          }, 50);
        }, 500); // 트랜지션 시간과 동일
      }

      function startRolling() {
        interval = setInterval(rollMerit, 2000); // 2초마다 롤링
      }

      function stopRolling() {
        clearInterval(interval);
      }

      startRolling(); // 롤링 시작

      // 호버 시 모든 항목 표시
      meritContainer.addEventListener("mouseenter", () => {
        stopRolling();
        merits.forEach((item) => {
          item.style.opacity = "1";
          item.style.transform = "translateY(0)";
        });
      });

      meritContainer.addEventListener("mouseleave", () => {
        startRolling(); // 롤링 다시 시작
      });
    });
}

/** moveTop */
export function moveTop() {
  var footerQuick = document.querySelector(".ft_quick");
  var moveTopButton = document.querySelector(".move_top");

  function updateButtonVisibility() {
    var scrollY = window.scrollY;
    var windowHeight = window.innerHeight;

    // 스크롤이 화면 높이보다 많이 내려가면 move_top 버튼 활성화
    if (scrollY > windowHeight) {
      footerQuick.classList.add("on");
    } else {
      footerQuick.classList.remove("on");
    }
  }

  function scrollToTop() {
    var startTime;
    var duration = 300;
    var startScrollY = window.scrollY;
    var endScrollY = 0;

    function animateScroll(currentTime) {
      if (!startTime) {
        startTime = currentTime;
      }

      var elapsedTime = currentTime - startTime;
      var progress = Math.min(elapsedTime / duration, 1);

      window.scrollTo(0, startScrollY + (endScrollY - startScrollY) * progress);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    }

    requestAnimationFrame(animateScroll);
  }

  window.addEventListener("scroll", updateButtonVisibility);
  moveTopButton.addEventListener("click", scrollToTop);

  // 초기 상태 설정
  updateButtonVisibility();
}
